import {
  DropDownV2 as CXDropdown,
  IDropdownV2 as CXIDropdown,
  IDropdownV2Item as CXIDropdownItem
} from '@sanlamcx/react-ui-next-dropdown-v2';

type Dropdown = typeof CXDropdown;
type DropdownItem = typeof CXDropdown;

export const Dropdown: Dropdown = CXDropdown;
export const DropdownItem: DropdownItem = CXDropdown;

export type IDropdown = CXIDropdown;
export type IDropdownItem = CXIDropdownItem;
